import React from "react";
import { ImageConverterSection5 } from "components/features/ImageConverter/ImageConverterSection5";
import { ImageConverterPageTemplateInterface } from "@/templates/ImageConverterPageTemplateInterface";
import ImageConverterSection10FAQ from "components/features/ImageConverter/ImageConverterSection10FAQ";
import { ImageConverterSection6 } from "components/features/ImageConverter/ImageConverterSection6";
import ImageConverterSection8Highlight from "components/features/ImageConverter/ImageConverterSection8Highlight";
import ImageConverterCollection from "components/features/ImageConverter/ImageConverterCollections";

const ImageConverterPreToolsArea = ({
    template,
    variables,
}: {
    template: ImageConverterPageTemplateInterface;
    variables?: Record<any, any>;
}) => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-4  md:mx-20">
                <ImageConverterSection5 template={template} variables={variables} />
                <ImageConverterSection6 template={template} />
                <ImageConverterSection8Highlight template={template} />
                <ImageConverterSection10FAQ template={template} variables={variables} />
                <ImageConverterCollection />
            </div>
        </div>
    );
};

export default ImageConverterPreToolsArea;
